export function denormalizeData(dataFromApi) {
  const { data, included } = dataFromApi || {};
  if (!included || !included.length) {
    return data;
  }

  /**
   * Группируем `included` в словарь с ключами по типу данных.
   */
  const includedDict = createIncludedDict(included);

  if (Array.isArray(data)) {
    return data.map(resolveRelationship.bind(this, includedDict));
  }

  return resolveRelationship(includedDict, data);
}

export function createIncludedDict(included) {
  return included.reduce((result, item) => {
    if (!result[item.type]) {
      result[item.type] = {};
    }

    result[item.type][item.id] = item.attributes;

    return result;
  }, {});
}

function resolveRelationship(dictionary, entity) {
  if (!entity?.relationships) {
    return entity;
  }

  /**
   * Заполняем relationships из словаря.
   */
  const relationships = Object
    .keys(entity.relationships)
    .reduce((result, name) => {
      const data = entity.relationships[name].data;
      const contentArr = []
        .concat(data)
        .map(item => {
          if (!item) {
            return item;
          }

          return {
            ...item,
            attributes: dictionary[item.type][item.id],
          };
        });

      result[name] = {
        data: Array.isArray(data) ? contentArr : contentArr[0],
      };

      return result;
    }, {});

  return {
    ...entity,
    relationships,
  };
}

/**
 * @param {object, array} data данные которые передаются в запрос
 * @param {string} requestParamName имя параметра для запроса
 * @param {string[]} externalParams если нужно в карточку добавить кастомное поле
 * @return {string} возвращает строку для нужного параметра
 */
export function filterRequiredParams(data, requestParamName, externalParams) {
  const params = Array.isArray(data) ? data : Object.keys(data).map(name => data[name]);

  let paramName;

  if (requestParamName === 'include') {
    paramName = 'requiredPayloadImports';
  } else if (requestParamName === 'fields') {
    paramName = 'requiredPayloadFields';
  }

  return params
    .filter(item => item && item[paramName])
    .map(item => item[paramName])
    .reduce((prev, next) => prev.concat(next), externalParams || [])
    .filter((name, i, list) => list.indexOf(name) === i)
    .join(',');
}
